import { useState } from "react";
import { EyeOff, X } from "lucide-react";
import { api, errorText } from "../lib/api";

// Admin-only "mark as intentional": hides one finding (or a whole duplicate group) until it changes
export const IgnoreButton = ({ check, item, group, label = "Ignore", testId, onDone }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e?.preventDefault();
    setBusy(true);
    setError("");
    try {
      const body = group ? { check, group, reason } : { check, type: item.type, id: item.id, reason };
      const r = await api.post("/admin/hygiene/ignores", body);
      setOpen(false);
      setReason("");
      onDone?.(r.data);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };
  if (!open) {
    return (
      <button
        type="button"
        data-testid={testId}
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        title={group ? "Mark this whole group as intentional – hidden until its members change" : "Mark this finding as intentional – hidden until it changes"}
        className="inline-flex items-center gap-1 rounded-full border border-panel-border px-2 py-0.5 text-[11px] font-semibold text-slate-500 hover:border-slate-400 hover:text-ink transition-colors shrink-0"
      >
        <EyeOff className="w-3 h-3" /> {label}
      </button>
    );
  }
  return (
    <form onSubmit={submit} className="inline-flex items-center gap-1.5 flex-wrap" data-testid={`${testId}-form`} onClick={(e) => e.stopPropagation()}>
      <input
        autoFocus
        data-testid={`${testId}-reason`}
        value={reason}
        maxLength={300}
        onChange={(e) => setReason(e.target.value)}
        placeholder="Reason (optional)"
        className="w-40 rounded-md border border-panel-border bg-panel px-2 py-0.5 text-[11px] text-ink outline-none focus:border-brand"
      />
      <button type="submit" data-testid={`${testId}-confirm`} disabled={busy} className="rounded-full bg-ink text-page px-2.5 py-0.5 text-[11px] font-semibold hover:bg-ink/85 disabled:opacity-50">
        {busy ? "…" : "Confirm"}
      </button>
      <button type="button" data-testid={`${testId}-cancel`} onClick={() => setOpen(false)} className="text-slate-400 hover:text-ink" aria-label="Cancel">
        <X className="w-3.5 h-3.5" />
      </button>
      {error && <span className="text-[11px] text-brand">{error}</span>}
    </form>
  );
};
